import { useState, useEffect } from 'react';
import { api } from '../hrApi';
import { useAuth } from '../hrAuth';

let _cache = null;

export default function EmployeeSelect({ value, onChange }) {
  const { user } = useAuth();
  const [members, setMembers] = useState(_cache || []);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    if (_cache) return;
    api('/team').then(d => { _cache = d.members; setMembers(d.members); }).catch(() => {});
  }, []);

  const filtered = members.filter(m =>
    !filter || `${m.employee_id} ${m.name} ${m.department}`.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="empsel">
      <label className="note">Employee:</label>
      <input className="searchbox" placeholder="Search employee…" value={filter}
             onChange={e => setFilter(e.target.value)} />
      <select value={value} onChange={e => onChange(e.target.value)}>
        <option value="">Myself ({user.employee_id})</option>
        {filtered.map(m => (
          <option key={m.employee_id || m.email || Math.random()} value={m.employee_id}>
            {m.employee_id} — {m.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export function clearTeamCache() { _cache = null; }
